export default function HeroSection() {
  return (
    <section className="relative w-full min-h-[600px] md:min-h-[700px] flex items-center overflow-hidden">
      {/* Background pattern with product images */}
      <div className="absolute inset-0 bg-background-50">
        <div className="absolute inset-0 opacity-[0.06]" style={{
          backgroundImage: `url(https://readdy.ai/api/search-image?query=Overhead%20flat%20lay%20of%20various%20fashion%20items%20including%20leather%20wallet%20sunglasses%20watch%20and%20scarf%20arranged%20artistically%20on%20warm%20cream%20linen%20fabric%20surface%20diffused%20natural%20window%20light%20from%20left%20side%20gentle%20organic%20shadows%20minimalist%20editorial%20photography%20style%20with%20muted%20beige%20and%20ivory%20palette%20high%20detail%20texture%20on%20every%20item&width=1800&height=1200&seq=hero-bg-v3-0001&orientation=landscape)`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          backgroundRepeat: 'no-repeat',
        }}></div>
      </div>

      <div className="absolute inset-0 bg-gradient-to-b from-background-50/40 via-background-50/20 to-background-50"></div>

      {/* Content */}
      <div className="relative w-full px-6 md:px-10 lg:px-16">
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-0">
          {/* Left: Text content - 40% */}
          <div className="w-full lg:w-[40%] flex flex-col items-start pt-10 lg:pt-0">
            <span className="inline-block px-3 py-1 rounded-full border border-foreground-200 text-xs font-medium text-foreground-500 tracking-wide mb-6">
              Spreadsheet Guide 2025
            </span>

            <h1 className="text-5xl md:text-6xl lg:text-7xl font-heading leading-none mb-2">
              <span className="font-bold text-foreground-900">litbuy</span>
            </h1>
            <h1 className="text-5xl md:text-6xl lg:text-7xl font-heading font-light leading-none text-secondary-400 mb-10">
              spreadsheet
            </h1>

            <p className="text-base md:text-lg text-foreground-600 leading-relaxed max-w-md mb-8">
              Your ultimate resource for mastering Litbuy Spreadsheet. Discover comprehensive guides, step-by-step tutorials, and expert tips to optimize your product management workflow.
            </p>

            <a
              href="/article/what-is-litbuy-spreadsheet"
              className="inline-flex items-center gap-2 text-foreground-800 font-medium text-sm border-b border-foreground-300 hover:border-primary-500 hover:text-primary-500 transition-colors duration-200 pb-1 cursor-pointer whitespace-nowrap"
            >
              Explore All Articles
              <span className="w-4 h-4 flex items-center justify-center">
                <i className="ri-arrow-right-line"></i>
              </span>
            </a>
          </div>

          {/* Right: Visual cards - 60% */}
          <div className="w-full lg:w-[60%] relative h-[320px] md:h-[420px] lg:h-[500px]">
            {/* Small square card - top left */}
            <div className="absolute left-[5%] top-[8%] w-[170px] h-[170px] md:w-[200px] md:h-[200px] rounded-2xl overflow-hidden z-10" style={{boxShadow: '0 4px 30px rgba(0,0,0,0.06)'}}>
              <img
                src="https://readdy.ai/api/search-image?query=Cream%20colored%20minimalist%20canvas%20sneakers%20placed%20on%20a%20raw%20concrete%20cube%20pedestal%20in%20a%20bright%20airy%20room%20with%20white%20walls%20soft%20morning%20sunlight%20streaming%20through%20sheer%20curtains%20casting%20long%20delicate%20shadows%20clean%20Scandinavian%20aesthetic%20crisp%20textures%20on%20shoe%20fabric%20and%20laces%20editorial%20product%20photography&width=400&height=400&seq=hero-sm-v3-a7x3&orientation=squarish"
                alt="Litbuy Spreadsheet product showcase"
                className="w-full h-full object-cover object-top"
                loading="lazy"
              />
            </div>

            {/* Large vertical card - bottom right */}
            <div className="absolute right-[8%] bottom-[5%] w-[180px] h-[240px] md:w-[220px] md:h-[300px] rounded-2xl overflow-hidden z-20" style={{boxShadow: '0 4px 30px rgba(0,0,0,0.06)'}}>
              <img
                src="https://readdy.ai/api/search-image?query=Elegant%20light%20beige%20trench%20coat%20draped%20over%20a%20minimal%20wooden%20valet%20stand%20against%20a%20soft%20ivory%20plaster%20wall%20with%20subtle%20texture%20warm%20golden%20hour%20light%20from%20a%20nearby%20window%20creating%20gentle%20highlights%20on%20the%20fabric%20folds%20luxurious%20editorial%20fashion%20photography%20with%20airy%20atmosphere%20and%20delicate%20cream%20tones&width=500&height=700&seq=hero-lg-v3-k9m2&orientation=portrait"
                alt="Litbuy Spreadsheet fashion showcase"
                className="w-full h-full object-cover object-top"
                loading="lazy"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}